// extracted by mini-css-extract-plugin
export default {"plots":"ListPlots_plots__0kuCq","emptyList":"ListPlots_emptyList__XMXiS","buyBtn":"ListPlots_buyBtn__7QJ6Q"};